<template>
  <div>
    <Header></Header>
    <div class="cookie-content">
      <div class="wrap">
        <!-- <img src="../../assets/images/cookie.png" alt="cookie" /> -->
        <!-- <h1 class="ck">{{ $t("cookie") }}</h1> -->
      </div>
      <h1>{{ $t("cookie") }}</h1>

      <p class="title">{{ $t('cookieTime1') }}<br />{{ $t('cookieTime2') }}</p>

      <p>{{ $t('cookieDes') }}</p>
      <p class="title">
        {{ $t('cookieAdmin') }}
      </p>
      <p>
        {{ $t('cookieAdmin1') }}
      </p>
      <p class="title">
        {{ $t('cookie1') }}
      </p>
      <p>
        {{ $t('cookie2') }}
      </p>
      <p class="title">
        {{ $t('cookie3') }}
        <br>
      </p>
      <p>
        {{ $t('cookie5') }}
      </p>
      <p class="title">
        {{ $t('cookie9') }}
      </p>
      <p> {{ $t('cookie10') }} <br />{{ $t('cookie101') }} </p>
      <ul>
        <li>{{ $t('cookie11') }}</li>
        <li>{{ $t('cookie12') }}</li>
      </ul>

      <p class="title">
        {{ $t('cookie13') }}
      </p>
      <p>
        {{ $t('cookie14') }}
      </p>
      <p class="title">
        {{ $t('cookie17') }}
      </p>
      <p>{{ $t('cookie18') }}</p>
      <p class="title">{{ $t('cookie20') }}</p>
      <p>{{ $t('cookie21') }}<br />
        {{ $t('cookie212') }}<br />
        {{ $t('cookie22') }}<br />

      </p>
      <p class="title"> {{ $t('cookie23') }} </p>
      <p>{{ $t('cookie24') }}</p>
      <p class="title"> {{ $t('cookie25') }} </p>
      <p>
        {{ $t('cookie26') }}<br />
        {{ $t('cookie27') }}<br />
      </p>
      <p class="title">{{ $t('cookie28') }}</p>
      <p>
        {{ $t('cookie29') }}<br />
        {{ $t('cookie39') }}<br />
        {{ $t('cookie40') }}<br />
        {{ $t('cookie32') }}<br />
        {{ $t('cookie33') }}<br />
      </p>
    </div>
    <div class="cookie-setting">
      <div class="setting">
        <div class="status">
          <img src="../../assets/images/accept.png" alt="accept" v-if="hasAcceptCookie">
          <img src="../../assets/images/forbid.png" alt="forbid" v-else>
          <p>
            <span v-if="hasAcceptCookie" class="bold">{{$t('have_accept')}}</span>
            <span  class="bold" v-else>{{$t('have_reject')}}</span>
            <span>{{$t('cookie_status')}}</span>
          </p>
        </div>
  
        <p class="operation">
          <img src="../../assets/images/cookie_yes.png" alt="agree" v-if="hasAcceptCookie">
          <img src="../../assets/images/disagree.png" alt="agree" v-else>
          <span>{{$t('accept')}}</span>
        </p>
  
        <el-button class="forbid" v-if="hasAcceptCookie" @click="settingCookie">{{$t('reject_cookie')}}</el-button>
        <el-button class="accept" v-else @click="settingCookie">{{$t('accept_cookie')}}</el-button>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import { getCookie, setCookie } from "@/utils/index.js";
  export default {
    data() {
      return {
        hasAcceptCookie: false,
        cookieName: 'CHANG_CHENG_COOKIE',
      };
    },
    created() {
      console.error(getCookie(this.cookieName));
      if (getCookie(this.cookieName) == "true") {
        this.hasAcceptCookie = true;
      } else {
        this.hasAcceptCookie = false;
      }
    },
    methods: {
      settingCookie() {
        if (getCookie(this.cookieName) == "true") {
          setCookie(this.cookieName, false);
          this.hasAcceptCookie = false;
        } else {
          setCookie(this.cookieName, true);
          this.hasAcceptCookie = true;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .cookie-content {
    margin: -40px 140px 0px 139px;
    padding: 50px 50px 30px 60px;
    text-align: left;
    background: rgb(194 191 186 / 10%);
    color: #000;
    border-bottom: 1px solid rgba(153, 153, 153, 0.2);


    .wrap {
      img {
        margin-right: 20px;
      }
    }

    @media (max-width: 767px) {
      margin: 0;
      padding: 50px 20px 50px 24px;
    }
  }

  .cookie-setting {
    margin: 0px 140px 120px;
    padding: 0px 59px 50px;
    text-align: left;
    background: rgb(194 191 186 / 10%);
    color: #000;
    border-top: 1px solid rgba(153, 153, 153, 0.2);

    @media (max-width: 767px) {
      margin: 0;
      padding: 30px 25px 60px;
    }
  }

  .wrap {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    img {
      margin-right: 20px;
    }
  }

  p {
    font-size: 18px;
    line-height: 28.5px;

    &.last-update {
      font-size: 16px;
      margin-bottom: 0;

      &+p {
        margin-top: 0;
      }
    }

    /* 加粗标题 */
    &.title,
    &.sub-title {
      font-size: 18px;
      font-family: NexaBold;
      margin-top: 25px;
      margin-bottom: 25px;

      @media (max-width: 767px) {
        font-size: 14px;
        text-align: left;
      }

      /* 段落字体 */
      &+p {
        margin-top: 0;
        font-size: 16px;
        line-height: 30px;
        font-family: NexaLight;
        font-weight: 300;

        @media (max-width: 767px) {
          font-size: 14px;
          text-align: left;
        }
      }
    }

    &.sub-title {
      font-size: 14px;
    }
  }

  h1 {
    font-size: 18px;
    text-align: center;
    font-family: NexaBold;

    @media (max-width: 767px) {
      font-size: 16px;
      text-align: left;
    }
  }

  h6 {
    font-size: 18px;
    margin: 0;
    line-height: 28px;
    font-weight: normal;

    @media (max-width: 767px) {
      font-size: 14px;
      text-align: left;
    }
  }

  ul {
    padding-left: 1em;
    line-height: 30px;
    font-size: 16px;
  }

  .setting {
    background: #FFF;
    padding: 40px 0px 40px 50px;
    margin-top: 30px;
    width: 500px;
    height: 272px;
    box-shadow: 0px 1px 10px 0px #e6e6e6;

    @media (max-width: 767px) {
      padding: 30px 20px;
      width: 99%;
    }

    .status {
      display: flex;
      align-items: center;
      img {
        width: 40px;
      }
      p {
        display: flex;
        flex-direction: column;
        margin: 20px;

        span:first-child {
          font-size: 20px;
          color: #000000;

          @media (max-width: 767px) {
            font-size: 16px;
            line-height: 1.2;
          }
        }

        span:last-child {
          font-size: 14px;
          color: #C2BFBA;
        }
      }
    }

    .des {
      font-size: 14px;
      line-height: 26px;
      color: #000000;
    }

    .operation {
      display: flex;
      align-items: center;
      img {
        width: 20px;
      }
      span {
        margin-left: 10px;
        font-weight: 600;
        font-size: 16px;
        color: #000000;
      }
    }

    .el-button {
      border-radius: 100px;
      color: #fff;
      font-size: 14px;
      padding: 13px 50px;
      margin-top: 20px;

      @media (max-width: 767px) {
        width: 100%;
      }

      &.forbid {
        background: #727272;

        &:hover {
          border-color: #727272;
        }
      }

      &.accept {
        background: #13b0b9;

        &:hover {
          border-color: #13b0b9;
        }
      }
    }
  }
</style>